
import { tokens } from './tokens'

// Sub-app catalog: maps the value stored in Redux `state.selectedModule.value`
// (and the per-module sidebar/breadcrumb labels) to its visual identity.
//
// `id` matches the codes used in mock/dataMock.tsx and SelectedModuleSlice
// (e.g. "IN" for incidents, "EV" for events, etc.). `monogram` is the 2-letter
// label rendered inside the 40×40 sub-app tile at the top of the Sidebar.
//
// Colors are flat solids per the Figma rail design (node 31170:4) — the
// gradient variants from .figma/guidelines.md only apply to the marketing tile.

export interface SubAppDef {
  id: string
  route: string
  monogram: string
  color: string
  // Translation key under `navigation.modules.*.title` used for the sidebar
  // label when the Sider is expanded and for the breadcrumb segment.
  labelKey: string
}

export const SUB_APPS: SubAppDef[] = [
  { id: 'IN', route: '/issues',     monogram: 'IS', color: '#f5222d',          labelKey: 'navigation.modules.incidents.title' },
  { id: 'EV', route: '/events',     monogram: 'EV', color: '#ff6f00',          labelKey: 'navigation.modules.events.title' },
  { id: 'RI', route: '/risks',      monogram: 'RI', color: '#ff9800',          labelKey: 'navigation.modules.risks.title' },
  { id: 'PL', route: '/plans',      monogram: 'PL', color: '#77a23f',          labelKey: 'navigation.modules.plans.title' },
  { id: 'ID', route: '/indicators', monogram: 'ID', color: '#9b59b6',          labelKey: 'navigation.modules.indicators.title' },
]

export const DEFAULT_SUB_APP: SubAppDef = {
  id: 'GU',
  route: '/',
  monogram: 'GU',
  color: tokens.colors.primary,
  labelKey: 'navigation.appSwitcher',
}

export function getSubAppById(id: string | undefined | null): SubAppDef {
  if (!id) return DEFAULT_SUB_APP
  return SUB_APPS.find((s) => s.id === id) ?? DEFAULT_SUB_APP
}

export function getSubAppByRoute(pathname: string): SubAppDef | undefined {
  return SUB_APPS.find((s) => pathname === s.route || pathname.startsWith(s.route + '/'))
}
